import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';

import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import theme from './styles/theme';
import store, { persistor } from './store';

import Snackbar from './components/Snackbar';

import Routes from './routes';

registerLocale('pt-BR', ptBR);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Snackbar>
            <Routes />
          </Snackbar>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}
